import { Box, Button, Image, Text } from '@chakra-ui/react';
import React from 'react';
import WelcomeLogo from '../assets/images/WelcomeLogo.png';
import WelcomeLogoAR from '../assets/images/WelcomeLogoAR.png';
import { WelcomeProps } from '../interfaces/components';
import { WelcomeModal } from '../content';

const Welcome = ({ activeLocale, active, setActive }: WelcomeProps) => {
  const onClose = () => {
    setActive();
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: 'startTagManager' });
  };

  return (
    <>
      <Box
        position="fixed"
        w="100%"
        h="100%"
        top="0"
        left="0"
        opacity={active ? 1 : 0}
        visibility={active ? 'visible' : 'hidden'}
        backgroundColor="rgba(0,0,0,0.1)"
        transition="all 1s"
        zIndex={4}
        onClick={onClose}
      />
      <Box
        zIndex={7}
        opacity={active ? 1 : 0}
        visibility={active ? 'visible' : 'hidden'}
        transition="all 0.5s"
        position="fixed"
        top={0}
        right={0}
        left={0}
        bottom={0}
        margin="auto"
        bg="white"
        padding="25px"
        width={['95vw', '350px', '450px', '450px', '450px']}
        height={['380px', '460px', '550px', '550px', '550px']}
      >
        <Box
          border="3px solid #FFCB00"
          width="100%"
          height="100%"
          display="flex"
          justifyContent="space-evenly"
          alignItems="center"
          flexDir="column"
        >
          <Box textAlign="center">
            <Text
              fontSize={['12px', '13px', '15px', '15px', '15px']}
              fontFamily={activeLocale === 'ar' ? 'GETwoLight' : 'RalewayMedium'}
            >
              {activeLocale === undefined || !((activeLocale as keyof typeof WelcomeModal) in WelcomeModal)
                ? WelcomeModal['en'].topOne
                : WelcomeModal[activeLocale as keyof typeof WelcomeModal].topOne}
            </Text>

            <Text
              fontSize={['18px', '20px', '25px', '25px', '25px']}
              fontFamily={activeLocale === 'ar' ? 'GETwoLight' : 'RalewayBold'}
              fontWeight="900"
            >
              {activeLocale === undefined || !((activeLocale as keyof typeof WelcomeModal) in WelcomeModal)
                ? WelcomeModal['en'].topTwo
                : WelcomeModal[activeLocale as keyof typeof WelcomeModal].topTwo}
            </Text>

            <Text
              fontSize={['12px', '13px', '15px', '15px', '15px']}
              fontFamily={activeLocale === 'ar' ? 'GETwoLight' : 'RalewayMedium'}
            >
              {activeLocale === undefined || !((activeLocale as keyof typeof WelcomeModal) in WelcomeModal)
                ? WelcomeModal['en'].topThree
                : WelcomeModal[activeLocale as keyof typeof WelcomeModal].topThree}
            </Text>
          </Box>

          <Box>
            <Text
              m="0 auto"
              textAlign="center"
              fontSize={['12px', '13px', '15px', '15px', '15px']}
              maxW={['100%', 'unset', 'unset', 'unset', 'unset']}
              fontFamily={activeLocale === 'ar' ? 'GETwoLight' : 'RalewayMedium'}
            >
              {activeLocale === undefined || !((activeLocale as keyof typeof WelcomeModal) in WelcomeModal)
                ? WelcomeModal['en'].welcome
                : WelcomeModal[activeLocale as keyof typeof WelcomeModal].welcome}
            </Text>
            {activeLocale === 'ar' ? (
              <Image src={WelcomeLogoAR} w={['100px', '120px', '150px', '150px', '150px']} />
            ) : (
              <Image src={WelcomeLogo} w={['100px', '120px', '150px', '150px', '150px']} />
            )}
          </Box>

          <Button
            bg="#FFCB00"
            borderRadius="0px"
            w={['100px', '150px', '200px', '200px', '200px']}
            height={['25px', '35px', '35px', '35px', '35px']}
            fontSize={['12px', '13px', '15px', '15px', '15px']}
            _hover={{ bg: 'rgb(255, 203, 0, 0.4)' }}
            _focus={{ bg: '#FFCB00' }}
            onClick={onClose}
            fontFamily={activeLocale === 'ar' ? 'GETwoLight' : 'RalewayMedium'}
          >
            {activeLocale === undefined || !((activeLocale as keyof typeof WelcomeModal) in WelcomeModal)
              ? WelcomeModal['en'].button
              : WelcomeModal[activeLocale as keyof typeof WelcomeModal].button}
          </Button>
        </Box>
      </Box>
    </>
  );
};
export default Welcome;
